import { render, staticRenderFns } from "./ProjectPersonRemove.vue?vue&type=template&id=0e3900a8&scoped=true&"
import script from "./ProjectPersonRemove.vue?vue&type=script&lang=js&"
export * from "./ProjectPersonRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3900a8",
  null
  
)

export default component.exports